const isDevEnv = process.env.NODE_ENV === 'development';

export default isDevEnv;
